import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { InputGroup, FormControl, Button, Image } from 'react-bootstrap';
import { s360ConfigService } from "../Services/S360Config";

//To be done.
class CheckBox extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-initial-form-checkbox-container" style={this.formInputBoxContainerStyle()} >
                <div className="s360-initial-form-checkbox-label">
                {this.props.item.label}
                </div>
                <div className="s360-initial-form-checkbox-option"  style={this.formInputBoxStyle()}>
                    <InputGroup>
                        <InputGroup.Prepend>
                                {this.props && this.props.item.options && this.props.item.options.map(eachOption => {
                                    return <><InputGroup.Checkbox aria-label="Checkbox" onChange={(e) => { this.onCheckboxChanged(e.target.checked, eachOption); }} /> <span style={{paddingLeft:"5px"}}>{eachOption}</span><br/></>
                                })
                            }
                        </InputGroup.Prepend>
                    </InputGroup>
                </div>
            </div>
        );
    }

    checkedOptions = [];
    onCheckboxChanged = (isChecked, checkBoxOption) => {
        this.checkedOptions = this.checkedOptions.filter(i => i !== checkBoxOption);
        if (isChecked) {
            this.checkedOptions.push(checkBoxOption);
        }
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor:        s360ConfigService.config.designDetails.headerColor,
            backgroundColor:    s360ConfigService.config.designDetails.pageBackgroundColor,
            marginTop: "5px"
        }
    }

    value = () => {
        if (this.checkedOptions.length === 0) { return {} ; }
        let aValue = {};
        aValue[this.props.item.label] = this.checkedOptions;
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        return !(isRequired && this.checkedOptions.length === 0);
    }

    validationErrorMessage = () => {
        return "Please select " + this.props.item.label.toLowerCase() + ".";
    }
}


export default CheckBox;